export enum DefaultColorEnum {
  danger = '#EE3C37',
  dark = '#363949',
  light = '#f6f8fc',
  medium = '#6E6D6D',
  primary = '#003B3F',
  secondary = '#B0B1C1',
  success = '#018626',
  warn = '#EC9F24'
}
